import React, { useState, useContext, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { StoreContext } from "../store";
import "../App.css";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import ContactUsModal from "./atoms/molecules/ContactUsModal";
import { UpdateLogin, Logout } from "../actions";

let Navigation = (props) => {
  const { IsLogin, dispatch } = useContext(StoreContext);

  const [showContactModal, setShowContactModal] = useState(false);
  const handleLogout = () => {
    Logout(dispatch);
  };

  const hideModalClick = () => {
    setShowContactModal(false);
  };

  const handleShowContact = () => {
    setShowContactModal(true);
  };

  return (
    <div>
      <div className="login-div">
        {IsLogin ? (
          <span onClick={() => handleLogout()}>
            Logout
            {/* <Link to="/admin">
              <mark className="text-danger">Logout</mark>
            </Link> */}
          </span>
        ) : (
          ""
        )}
      </div>

      <div className="nav-bar">
        <div className="navSpan">
          <NavLink
            as={Link}
            to="/home"
            activeClassName="active"
            style={{ textDecoration: "none" }}
          >
            Home
          </NavLink>
        </div>
        <div className="navSpan">
          <NavLink
            as={Link}
            to="/landingspot"
            activeClassName="active"
            style={{ textDecoration: "none" }}
          >
            Landing Spot
          </NavLink>
        </div>
        <div className="navSpan">
          <NavLink
            as={Link}
            to="/importbirds"
            activeClassName="active"
            style={{ textDecoration: "none" }}
          >
            Imports
          </NavLink>
        </div>
        <div className="navSpan">
          <NavLink
            as={Link}
            to="/usbirds"
            activeClassName="active"
            style={{ textDecoration: "none" }}
          >
            USA Birds
          </NavLink>
        </div>
        <div className="navSpan">
          <NavLink
            as={Link}
            to="/forsale"
            activeClassName="active"
            style={{ textDecoration: "none", color: "black" }}
          >
            For Sale & Sold
          </NavLink>
        </div>

        <div className="navSpan" onClick={() => handleShowContact()}>
          <a>Contact Us</a>
        </div>
        {showContactModal ? (
          <ContactUsModal
            show={showContactModal}
            closeModal={() => hideModalClick()}
          />
        ) : null}
      </div>
    </div>
  );
};
export default Navigation;
